module.exports = __webpack_public_path__ + "media/images/squadBet__iconSwapSample-ec8ae944fde58248df540cb5a8084eea.png";